const $ = require('jquery');
$.noConflict();
$.DataTable = require('datatables.net');
import WithSystem from './../service/WithSystem';
export default class LeanerScomTbl extends React.Component{
  constructor(props) {
    super(props);
    this.tablerender = null;
  }
  componentDidMount() {
    this.leanerScormreportrender();
  }
  leanerScormreportrender = () => {
    this.tablerender = $(this.refs.main1).DataTable({
      "lengthMenu": [window.showlimit],
      "lengthChange": false,
      "bFilter": false,
      "stateSave": false,
      "scrollX": true,
      "ordering": true,
      autoWidth: false,
      "columnDefs": [
      ],
      "order": [[0, "asc"]],
      "processing": true,
      "serverSide": true,
      ajax: {
        type: "POST",
        data: { 'learnerid': this.props.learnerid, 'learnerCourseid': this.props.learnerCourseid },
        beforeSend: function () {
          $("#progress-filter-loading").addClass("show");
        },
        url: admin_url + 'Archive_consolidate_report/learners_scorm_report'+__setSsAuthUrl,
        "dataSrc": function (response) {
          $("#progress-filter-loading").removeClass("show");
          return response.aaData;
        },
      },
      'columns': [
        {
          "mRender": function (data, type, row) {
            return `${row.name}`;
          }
        },
        {
          "mRender": function (data, type, row) {
            if (row.complete_date != ""  && row.complete_date != null  && row.progress == 100){
              var formateed_date = formatAMPM(changeDatesFormat(convertUTCtoLocalTime(row.complete_date)));
              return `${formateed_date}`;
            }else{
              return `-`;
            }
          }
        },
        {
          "mRender": function (data, type, row) {
            if (row.time_spent != null){
              
              return `${secondsToHmsScorm(row.time_spent)}`;
            }else{
              return `-`;
            }
          }
        },   
      ],
      "language": {
        "emptyTable": innernoMsg
      },
      "drawCallback": function (settings) {
      },
    });
  }
  componentDidUpdate(prevProps) {
  }

  componentWillUnmount() {
    $('#table_id1').DataTable().destroy();
    $('#myTable').DataTable().destroy();
    $('.data-table-wrapper')
      .find('table')
      .DataTable()
      .destroy(true);
  }
  render() {
    return (<div>
      <table className="display" width="100%" id="table_id1" ref="main1">
        <thead>
          <tr>
            <th className="no-sort">Scorm Name</th>
            <th className="no-sort">Completion Date</th>
            <th className="no-sort">Time Spent</th>

          </tr>
        </thead>
      </table>
    </div>)
  }
}